module.exports = __webpack_public_path__ + "img/狗脊.6c1b04b5.jpg";